import { useState } from 'react';
import { CompetitorData, DateRange } from '../types/dataTypes';
import { mockData } from '../data/mockData';

export const useCompetitorData = () => {
  const [competitorData, setCompetitorData] = useState<CompetitorData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>('last30days');

  const analyzeCompetitors = async (url: string, competitors: string[], dateRange: DateRange) => {
    setIsLoading(true);
    setError(null);
    
    try {
      // In a real implementation, this would make API calls to various services
      // For this demo, we'll simulate an API call and return mock data
      await new Promise(resolve => setTimeout(resolve, 1500)); // Simulate API delay
      
      // Generate competitor names from URLs if provided
      const competitorNames = competitors.map(url => {
        try {
          const domain = new URL(url).hostname.replace('www.', '');
          return domain.split('.')[0];
        } catch (e) {
          return url;
        }
      });
      
      // Create a copy of mock data and update it with the provided URLs
      const data = { ...mockData };
      
      // Update your website URL
      data.yourWebsite = url;
      
      // Update competitor data
      data.competitors = competitorNames.map((name, index) => ({
        name: name.charAt(0).toUpperCase() + name.slice(1),
        url: competitors[index]
      }));
      
      setCompetitorData(data);
    } catch (err) {
      setError('Failed to analyze competitors. Please try again.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    competitorData,
    isLoading,
    error,
    analyzeCompetitors,
    selectedDateRange,
    setSelectedDateRange
  };
};